import { useState, useEffect } from 'react';
import { throttle } from 'diskho';

var useBrowserDimensions = () => {
  var _useState = useState(process.browser ? window.innerWidth : 0),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = useState(process.browser ? window.innerHeight : 0),
      height = _useState2[0],
      setHeight = _useState2[1];

  useEffect(() => {
    if (process.browser) {
      var handleResize = throttle(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      }, 1000);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [width, height]);
  return {
    width,
    height
  };
};

export default useBrowserDimensions;
//# sourceMappingURL=use-browser-dimensions.js.map
